import React from 'react'
import CheckoutGuestInfo from './CheckoutGuestInfo'
import CheckoutPayment from './CheckoutPayment'
import Breadcrumb from '../common/Breadcrumb'
import {AppView, BookingStatusValues, PaymentStatusValues} from '../../types'
import ShoppingCart from '../cart/ShoppingCart'
import {useAppDispatch, useAppSelector} from '../../store/hooks'
import CheckoutProcessingModal from './CheckoutProcessingModal'
import {setAppView} from '../../store/slices/appViewSlice'
import {selectIsValidGuestInfo} from '../../store/slices/guestInfoSlice'
import {
  selectCartHasItems,
  selectHasMemberRate
} from '../../store/slices/shoppingCartSlice'
import {clearSearchParams} from '../../store/slices/searchParamsSlice'
import EmptyCart from '../../assets/ibe-empty-cart.png'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faStar} from '@fortawesome/free-solid-svg-icons'
import {selectIsAuthenticated} from '../../store/slices/userSlice'
import clsx from 'clsx'
import {
  selectPaymentSessionId,
  selectPaymentStatus
} from '../../store/slices/paymentSlice'
import {selectBookingStatus} from '../../store/slices/bookingSlice'
import MemberRateBadge from '../common/MemberRateBadge'

const CheckoutView = () => {
  const dispatch = useAppDispatch()
  const hasItems = useAppSelector(selectCartHasItems)
  const hasMemberRate = useAppSelector(selectHasMemberRate)
  const isAuthenticated = useAppSelector(selectIsAuthenticated)
  const paymentSessionId = useAppSelector(selectPaymentSessionId)
  const paymentStatus = useAppSelector(selectPaymentStatus)
  const bookingStatus = useAppSelector(selectBookingStatus)
  const isValidGuestInfo = useAppSelector(selectIsValidGuestInfo)

  return (
    <section>
      <Breadcrumb />
      <h1 className="font-semibold my-1">
        Complete your booking with Placemakr
      </h1>
      {hasItems ? (
        <div>
          {/* Member rate message */}
          {hasMemberRate && !isAuthenticated && (
            <div className="card card-compact bg-white border shadow mt-4 mx-auto w-3/4">
              <div
                className={clsx(
                  'card-body flex ',
                  'flex-col items-start gap-1',
                  'md:flex-row md:items-center md:gap-4'
                )}
              >
                <MemberRateBadge />
                <p className="flex-1 text-sm text-light-primary italic">
                  You've selected an exclusive Placemakr Member rate. Join for
                  free or sign in below. Don't want to join? Please select a
                  non-Member Rate.
                </p>
              </div>
            </div>
          )}
          <div className="flex flex-col lg:flex-row gap-4 mt-4">
            <div className="flex-1 lg:order-last">
              <ShoppingCart />
            </div>
            <div className="divider lg:hidden my-0" />
            <div className="flex-1 flex flex-col gap-4">
              <CheckoutGuestInfo />
              <CheckoutPayment isActive={isValidGuestInfo} />
              <CheckoutProcessingModal
                isOpen={
                  paymentStatus === PaymentStatusValues.Processing ||
                  paymentStatus === PaymentStatusValues.Failure ||
                  bookingStatus === BookingStatusValues.Processing ||
                  bookingStatus === BookingStatusValues.Failure
                }
                paymentSessionId={paymentSessionId}
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="mt-8 flex flex-col gap-4 items-center">
          <img
            src={EmptyCart}
            alt="Shopping cart is empty image."
            className="max-h-72"
          />
          <h2 className="text-xl font-semibold">Your cart is empty</h2>
          <p className="text-center">
            Please add items to your cart before proceeding to checkout.
          </p>
          <button
            className="btn btn-secondary"
            onClick={() => {
              dispatch(clearSearchParams())
              dispatch(setAppView(AppView.HOME))
            }}
            aria-label="Start a new search."
          >
            start a new search
          </button>
        </div>
      )}
    </section>
  )
}

export default CheckoutView
